export default "__VITE_ASSET__BiVifY0D__"